import { ref, toRaw } from 'vue';
import { message } from 'ant-design-vue';
import i18n from '@/i18n';

import { showErrorMessage } from '@/components/common/errorMessage';

export function useVRSSettingsPost(apiFunc, formState, validate, formStateProcessor, resetChangedState, errorsHandler, successHandler) {
	const isSubmitting = ref(false);
	if (formStateProcessor == undefined) {
		formStateProcessor = toRaw;
	}
	const t = i18n.global.t;
	const handleSettingsUpdateForm = response => {
		if (response.status === 'ok') {
			message.success(t('settings.vrsSettingsForm.messages.success'));
			resetChangedState();
			if (successHandler) {
				successHandler(response);
			}
		} else {
			showErrorMessage(response.errors);
		}
		isSubmitting.value = false;
	}
	const errorsHandler2 = errorsHandler || (err => {
		console.log('error', err);
	});
	const onSubmit = () => {
		validate().then(() => {
			isSubmitting.value = true;
			apiFunc(formStateProcessor(formState), handleSettingsUpdateForm);
		}).catch(errorsHandler2);
	};
	return { isSubmitting, onSubmit }
}
